function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ivory-feffe6': '','baby-blue-c6edf1': '','mint-c7f1d5': '','peach-fcd5bd': '','haint-blue-c3e4e9': '','hydrangea-a7bcd6': '','flo-blue-5c81c8': '','sea-foam-75b1a9': '','denim-69748a': '','mystic-blue-5c88da': '',};

    this.images = {'ivory': 'url("//follygolf.com/cdn/shop/files/Ivory_68x.png?v=10100857886300766132")','baby-blue': 'url("//follygolf.com/cdn/shop/files/Baby_Blue_68x.png?v=14397528383378025587")','mint': 'url("//follygolf.com/cdn/shop/files/Mint_68x.png?v=2494462345085531193")','peach': 'url("//follygolf.com/cdn/shop/files/Peach_68x.png?v=13678530466650212938")','haint-blue': 'url("//follygolf.com/cdn/shop/files/Haint_Blue_68x.png?v=14140510949180700977")','hydrangea': 'url("//follygolf.com/cdn/shop/files/Hydrangea_1_68x.png?v=5223234079175103290")','flo-blue': 'url("//follygolf.com/cdn/shop/files/Flo_Blue_68x.png?v=30495076830266019")','sea-foam': 'url("//follygolf.com/cdn/shop/files/Sea_Foam_0e589576-a9ea-4fe5-ac00-1b54aaad205e_68x.png?v=13672840109875627789")','denim': 'url("//follygolf.com/cdn/shop/files/Denim_65f216d3-3f57-437b-abe9-a051bffaba4f_68x.png?v=5876585608897365461")','mystic-blue': 'url("//follygolf.com/cdn/shop/files/Mystic_Blue_1_68x.png?v=16973681924946858311")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
